import { api } from '@/lib/api';
import type { WalkIncident, WalkIncidentSeverity, WalkIncidentType } from './types';

export type RaiseIncidentInput = { type: WalkIncidentType; severity: WalkIncidentSeverity; note: string };

// ---- Vendor (walker) ----
export async function list_vendor_incidents(booking_id: string): Promise<WalkIncident[]> {
  const res = await api.get<WalkIncident[]>(`/vendor/bookings/${booking_id}/incidents`);
  return res.data;
}

export async function raise_incident(booking_id: string, input: RaiseIncidentInput): Promise<WalkIncident> {
  const res = await api.post<WalkIncident>(`/vendor/bookings/${booking_id}/incidents`, input);
  return res.data;
}

export async function resolve_incident(
  booking_id: string,
  incident_id: string,
  resolution_note?: string,
): Promise<WalkIncident> {
  const res = await api.post<WalkIncident>(
    `/vendor/bookings/${booking_id}/incidents/${incident_id}/resolve`,
    resolution_note ? { resolution_note } : {},
  );
  return res.data;
}

// ---- Owner ----
export async function list_owner_incidents(booking_id: string): Promise<WalkIncident[]> {
  const res = await api.get<WalkIncident[]>(`/user/bookings/${booking_id}/incidents`);
  return res.data;
}

export async function acknowledge_incident(booking_id: string, incident_id: string): Promise<WalkIncident> {
  const res = await api.post<WalkIncident>(`/user/bookings/${booking_id}/incidents/${incident_id}/ack`);
  return res.data;
}
